__turbopack_context__.v({
  "accordionSlideOverwrite": "calendar-module-scss-module__wBVN-W__accordionSlideOverwrite",
  "day": "calendar-module-scss-module__wBVN-W__day",
  "dayButton": "calendar-module-scss-module__wBVN-W__dayButton",
  "disabled": "calendar-module-scss-module__wBVN-W__disabled",
  "fadeIn": "calendar-module-scss-module__wBVN-W__fadeIn",
  "fadeOut": "calendar-module-scss-module__wBVN-W__fadeOut",
  "focused": "calendar-module-scss-module__wBVN-W__focused",
  "outside": "calendar-module-scss-module__wBVN-W__outside",
  "scaleIn": "calendar-module-scss-module__wBVN-W__scaleIn",
  "scaleOut": "calendar-module-scss-module__wBVN-W__scaleOut",
  "selected": "calendar-module-scss-module__wBVN-W__selected",
  "today": "calendar-module-scss-module__wBVN-W__today",
  "zoomIn": "calendar-module-scss-module__wBVN-W__zoomIn",
  "zoomOut": "calendar-module-scss-module__wBVN-W__zoomOut",
});
